var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{attrs:{"href":_vm.href}},[_vm._t("prepend"),_vm._v("\n  "+_vm._s(_vm.number)+"\n\n  "),_vm._t("append")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }